// extracted by mini-css-extract-plugin
export default {"myCustomInput":"ContactForm_myCustomInput__O5hba","dark":"ContactForm_dark__V4JSz","light":"ContactForm_light__fVzMU"};